import React, { useContext, useEffect, useState } from 'react';
import { ProviderId } from 'firebase/auth';
import { AuthContext } from '../../context/AuthContext';
import { KickCounterContext } from '../../context/KickCounterContext';
import useFirestore from '../../hooks/useFirestore';
import useSignIn from '../../hooks/useSignIn';
import convertToFirestoreStorageFormat from '../../utils/sessionData';
import DownloadApp from './DownloadApp';
import styles from './SignIn.module.css';
import {
  APPLE_PROVIDER, LICENSE_AGREEMENT_LINK, PRIVACY_POLICY_LINK, TERMS_CONDITION_LINK,
} from '../../constants/constants';

const gmailLogo = require('../../assets/icons/gmail_logo.svg').default;
const appleLogo = require('../../assets/icons/apple_25.svg').default;
const fbLogo = require('../../assets/icons/fb.svg').default;

export default function SignIn() {
  const {
    signIn, error, success, isPending,
  } = useSignIn();
  const [isUploading, setIsUploading] = useState(false);
  const { user } = useContext(AuthContext);
  const { setSessionData, response } = useFirestore();
  const state = useContext(KickCounterContext);

  const upload = () => {
    const result = convertToFirestoreStorageFormat(
      state.sessionStartTime,
      state.sessionEndTime,
      state.strength,
      state.kickList,
    );
    setSessionData(user.uid, result);
  };

  const emailAlreadyExist = () => {
    if (error && error.code === 'auth/account-exists-with-different-credential') {
      return true;
    }
    return false;
  };

  useEffect(() => {
    setIsUploading(response.isPending);
  }, [response.isPending, response.error]);

  useEffect(() => {
    if (success) {
      setIsUploading(true);
      upload();
    }
  }, [success]);

  const getMessage = () => {
    if (emailAlreadyExist()) {
      return `Account with email "${error.customData.email}" already exits`;
    } if (error) {
      return 'Error: Unable to login';
    } if (response.error) {
      return 'Error: Unable to upload data';
    }
    return '\u00A0';
  };

  return (
    <div className={styles.container}>
      {(user && !isUploading && !error && !response.error) ? <DownloadApp />
        : (
          <p>
            <span>
              Create an account or sign in to save your data from this session.
            </span>
            <br />
            <br />
            Receive insights into your baby&#39;s movement
            patterns with the Flutter Care mobile app.
          </p>
        )}
      <div className={styles.errorMessage}>{getMessage()}</div>
      { isUploading && <div>Uploading your data.....</div>}
      { !user && (
      <>
        <button
          type="button"
          onClick={() => signIn(ProviderId.GOOGLE)}
          disabled={isPending}
          className={styles.signInButton}
        >
          <img src={gmailLogo} alt="" />
          Sign in with Gmail
        </button>
        <button
          type="button"
          onClick={() => signIn(ProviderId.FACEBOOK)}
          disabled={isPending}
          className={styles.signInButton}
        >
          <img src={fbLogo} alt="" />
          Sign in with Facebook
        </button>
        <button
          type="button"
          onClick={() => signIn(APPLE_PROVIDER)}
          disabled={isPending}
          className={styles.signInButton}
        >
          <img src={appleLogo} alt="" />
          Sign in with Apple
        </button>
        <p className={styles.disclaimer}>
          By creating an account, you are agreeing to the
          {' '}
          <a href={PRIVACY_POLICY_LINK} target="_blank" rel="noopener noreferrer">
            Privacy Policy
          </a>
          {', '}
          <a href={TERMS_CONDITION_LINK} target="_blank" rel="noopener noreferrer">
            Terms and Conditions
          </a>
          , and
          {' '}
          <a href={LICENSE_AGREEMENT_LINK} target="_blank" rel="noopener noreferrer">
            End User License Agreement
          </a>
          .
        </p>
      </>
      )}
    </div>
  );
}
